import * as React from 'react';
const SvgCalendarCheck = (props) => (
  <svg
    width={317}
    height={214}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_1_224247)">
      <path
        d="M161.563 75.7899C161.563 89.6518 150.353 100.862 136.37 100.862C136.129 100.862 134.08 100.862 119.013 100.862C108.526 100.862 91.7712 100.862 65.0117 100.862H52.2346C35.4798 101.223 22.1001 87.8437 22.1001 71.6917C22.1001 55.419 35.6004 41.9187 52.5963 42.7626C67.1814 -2.80082 133.959 3.58769 139.625 50.718C152.161 52.2851 161.563 62.8924 161.563 75.7899Z"
        fill="url(#paint0_linear_1_224247)"
      />
    </g>
    <path
      d="M136.369 100.862C150.231 100.862 161.561 89.6516 161.561 75.7898C161.561 61.9279 150.231 50.7178 136.369 50.7178C122.507 50.7178 111.176 61.9279 111.176 75.7898C111.176 89.6516 122.507 100.862 136.369 100.862Z"
      fill="url(#paint1_linear_1_224247)"
    />
    <path
      d="M95.2645 101.103C119.975 101.103 140.105 81.0936 140.105 56.3834C140.105 31.673 119.975 11.6638 95.2645 11.6638C70.5541 11.6638 50.4243 31.673 50.4243 56.3834C50.4243 81.0936 70.4335 101.103 95.2645 101.103Z"
      fill="url(#paint2_linear_1_224247)"
    />
    <g filter="url(#filter1_d_1_224247)">
      <path
        d="M294.899 141.259C294.899 156.483 282.588 168.795 267.231 168.795C266.966 168.795 264.715 168.795 248.167 168.795C236.65 168.795 218.25 168.795 188.859 168.795H174.827C156.425 169.192 141.731 154.497 141.731 136.758C141.731 118.886 156.558 104.059 175.224 104.986C191.243 54.9444 264.583 61.9608 270.804 113.723C284.572 115.444 294.899 127.094 294.899 141.259Z"
        fill="url(#paint3_linear_1_224247)"
      />
    </g>
    <path
      d="M267.231 168.796C282.457 168.796 294.9 156.484 294.9 141.26C294.9 126.036 282.457 113.724 267.231 113.724C252.008 113.724 239.563 126.036 239.563 141.26C239.563 156.484 252.008 168.796 267.231 168.796Z"
      fill="url(#paint4_linear_1_224247)"
    />
    <path
      d="M222.088 169.06C249.227 169.06 271.335 147.085 271.335 119.946C271.335 92.8071 249.227 70.8313 222.088 70.8313C194.949 70.8313 172.84 92.8071 172.84 119.946C172.84 147.085 194.816 169.06 222.088 169.06Z"
      fill="url(#paint5_linear_1_224247)"
    />
    <rect
      x={112.875}
      y={74.6367}
      width={91.25}
      height={77.75}
      rx={20}
      fill="white"
    />
    <path
      d="M112.625 83.6202C112.625 75.0794 112.625 70.809 114.288 67.5469C115.75 64.6774 118.083 62.3444 120.952 60.8824C124.214 59.2202 128.485 59.2202 137.025 59.2202H179.725C188.267 59.2202 192.537 59.2202 195.799 60.8824C198.669 62.3444 201.001 64.6774 202.463 67.5469C204.125 70.809 204.125 75.0794 204.125 83.6202V89.7202H112.625V83.6202Z"
      fill="#C3CCFF"
    />
    <rect
      x={137.125}
      y={48.1367}
      width={3}
      height={23}
      rx={1.5}
      fill="#9FAAFF"
    />
    <rect
      x={126.25}
      y={93.6367}
      width={3}
      height={52.75}
      rx={1.5}
      fill="#E9EBF4"
    />
    <rect
      x={141.25}
      y={93.6367}
      width={3}
      height={52.75}
      rx={1.5}
      fill="#E9EBF4"
    />
    <rect
      x={156.25}
      y={93.6367}
      width={3}
      height={52.75}
      rx={1.5}
      fill="#E9EBF4"
    />
    <rect
      x={171.25}
      y={93.6367}
      width={3}
      height={52.75}
      rx={1.5}
      fill="#E9EBF4"
    />
    <rect
      x={186.25}
      y={93.6367}
      width={3}
      height={52.75}
      rx={1.5}
      fill="#E9EBF4"
    />
    <rect
      x={194.875}
      y={103.512}
      width={3}
      height={74.25}
      rx={1.5}
      transform="rotate(90 194.875 103.512)"
      fill="#E9EBF4"
    />
    <rect
      x={194.875}
      y={118.512}
      width={3}
      height={74.25}
      rx={1.5}
      transform="rotate(90 194.875 118.512)"
      fill="#E9EBF4"
    />
    <rect
      x={194.875}
      y={133.512}
      width={3}
      height={74.25}
      rx={1.5}
      transform="rotate(90 194.875 133.512)"
      fill="#E9EBF4"
    />
    <rect
      x={177.375}
      y={47.7202}
      width={3}
      height={23}
      rx={1.5}
      fill="#9FAAFF"
    />
    <rect
      x={184.625}
      y={42.8867}
      width={39}
      height={39}
      rx={19.5}
      fill="#15B097"
    />
    <rect
      x={184.625}
      y={42.8867}
      width={39}
      height={39}
      rx={19.5}
      stroke="#F5F7FF"
      strokeWidth={3}
    />
    <path
      opacity={0.12}
      d="M218.625 62.3867C218.625 70.3948 212.134 76.8867 204.125 76.8867C196.117 76.8867 189.625 70.3948 189.625 62.3867C189.625 54.3786 196.117 47.8867 204.125 47.8867C212.134 47.8867 218.625 54.3786 218.625 62.3867Z"
      fill="#15B097"
      stroke="#15B097"
    />
    <path
      d="M197.375 62.3867L201.875 66.8867L210.875 57.8867M219.125 62.3867C219.125 70.6709 212.41 77.3867 204.125 77.3867C195.841 77.3867 189.125 70.6709 189.125 62.3867C189.125 54.1024 195.841 47.3867 204.125 47.3867C212.41 47.3867 219.125 54.1024 219.125 62.3867Z"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter2_d_1_224247)">
      <path
        d="M141.731 164.516C141.731 173.179 134.725 180.187 125.986 180.187C125.835 180.187 124.554 180.187 115.137 180.187C108.583 180.187 98.1113 180.187 81.3867 180.187H73.4009C62.9293 180.413 54.5669 172.05 54.5669 161.955C54.5669 151.785 63.0045 143.347 73.6269 143.874C82.7427 115.397 124.479 119.39 128.02 148.846C135.855 149.826 141.731 156.455 141.731 164.516Z"
        fill="url(#paint6_linear_1_224247)"
      />
    </g>
    <path
      d="M125.986 180.187C134.65 180.187 141.731 173.179 141.731 164.516C141.731 155.852 134.65 148.846 125.986 148.846C117.322 148.846 110.241 155.852 110.241 164.516C110.241 173.179 117.322 180.187 125.986 180.187Z"
      fill="url(#paint7_linear_1_224247)"
    />
    <path
      d="M100.297 180.336C115.741 180.336 128.322 167.831 128.322 152.387C128.322 136.943 115.741 124.438 100.297 124.438C84.8531 124.438 72.272 136.943 72.272 152.387C72.272 167.831 84.7778 180.336 100.297 180.336Z"
      fill="url(#paint8_linear_1_224247)"
    />
    <defs>
      <filter
        id="filter0_d_1_224247"
        x={0.100098}
        y={0.772705}
        width={183.462}
        height={133.096}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.997574 0 0 0 0 0.997981 0 0 0 0 0.999203 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_224247"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1_224247"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1_224247"
        x={119.731}
        y={59.9502}
        width={197.168}
        height={141.853}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.997574 0 0 0 0 0.997981 0 0 0 0 0.999203 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_224247"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1_224247"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_1_224247"
        x={32.5669}
        y={113.506}
        width={131.164}
        height={99.6858}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.997574 0 0 0 0 0.997981 0 0 0 0 0.999203 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_224247"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1_224247"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1_224247"
        x1={91.8313}
        y1={48.5907}
        x2={91.7859}
        y2={101.83}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={0.9964} stopColor="#F8F8FA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_224247"
        x1={108.496}
        y1={45.3199}
        x2={130.828}
        y2={69.7454}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBE1" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_224247"
        x1={46.2255}
        y1={35.8627}
        x2={81.4241}
        y2={49.6369}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E8F0" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_224247"
        x1={218.315}
        y1={111.387}
        x2={218.264}
        y2={169.858}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={0.9964} stopColor="#F8F8FA" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1_224247"
        x1={236.619}
        y1={107.795}
        x2={261.148}
        y2={134.621}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBE1" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1_224247"
        x1={168.229}
        y1={97.4085}
        x2={206.887}
        y2={112.536}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E8F0" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1_224247"
        x1={98.1489}
        y1={147.517}
        x2={98.1206}
        y2={180.791}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={0.9964} stopColor="#F8F8FA" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1_224247"
        x1={108.565}
        y1={145.472}
        x2={122.523}
        y2={160.738}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBE1" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1_224247"
        x1={69.6477}
        y1={139.562}
        x2={91.6467}
        y2={148.171}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E8F0" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgCalendarCheck;
